import { hasCookieConsent } from 'utils/cookieConsent';

const YM_COUNTER_ID = 105115263;

/** Счетчик кабинета только на публичном profile, не на dev и localhost. */
export function isProfileAnalyticsHost(hostname?: string): boolean {
  const host = (hostname || (typeof window === 'undefined' ? '' : window.location.hostname)).toLowerCase();
  return host === 'profile.myteacher.pro';
}

declare global {
  interface Window {
    ym?: (counterId: number, method: string, ...args: unknown[]) => void;
  }
}

/** Fire a Yandex Metrika JS goal when the counter is available. */
export function reachMetrikaGoal(goalName: string): void {
  if (typeof window === 'undefined' || !hasCookieConsent() || !isProfileAnalyticsHost()) return;
  if (typeof window.ym !== 'function') return;
  try {
    window.ym(YM_COUNTER_ID, 'reachGoal', goalName);
  } catch {
    // ignore - counter may be blocked by extensions
  }
}

export const METRIKA_GOALS = {
  /** Visit /registration (students & parents funnel entry) */
  registrationPage: 'registration_page',
  /** Successful student self-registration submit */
  registrationStudent: 'registration_student',
  /** Successful parent registering for a student */
  registrationParent: 'registration_parent',
  /** Student successfully created a bulletin/task */
  taskCreated: 'task_created',
  /** Tutor successfully responded to a task */
  taskResponded: 'task_responded',
} as const;
